export default __webpack_public_path__ + "static/media/MemoryCardGamePokemon.c8472303.gif";